import { drawPoint } from 'chart.js/helpers';

// 凡例マーカーを複数のキャンバスに個別に描画するプラグイン
// canvas要素の配列を取得する関数を canvasElementsFunction で与える
const pluginLegendOnCanvases = {
  id: 'legends_on_canvases',
  afterUpdate(chart, _, { canvasElementsFunction }) {
    const labels = chart.options.plugins.legend.labels.generateLabels(chart);
    labels.sort((a, b) => a.datasetIndex - b.datasetIndex);

    const cvsElms = canvasElementsFunction();
    if (cvsElms.length !== labels.length) {
      console.warn('凡例の数とキャンバスの数が違う');
    } else {
      for (let i = 0; i < labels.length; i++) {
        const l = labels[i];
        const cvs = cvsElms[i];
        const ctx = cvs.getContext('2d');
        ctx.clearRect(0, 0, cvs.width, cvs.height);
        ctx.fillStyle = l.fillStyle;
        ctx.strokeStyle = l.strokeStyle;
        const radius = cvs.width / 2 - 1;
        const options = {
          pointStyle: l.pointStyle,
          radius: radius,
          rotation: l.rotation,
          borderWidth: l.lineWidth
        };
        ctx.save();
        ctx.lineWidth = l.lineWidth;
        drawPoint(ctx, options, cvs.width / 2, cvs.height / 2);
        ctx.restore();
      }
    }
  },
};

export default pluginLegendOnCanvases;